export default __webpack_public_path__ + "static/media/Ingesan_NEG.697780f8.png";